<template>
<div class="x_box">
    <div class="x_header">
        <router-link to="/income" class="btn btn-outline-primary btn-sm"><i class="fa fa-plus-circle"></i> {{$t('btn.back')}}</router-link>
        <b-btn variant="outline-primary" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('btn.save')}}</b-btn>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-header nb">
                <span class="card-title">
                    <i class="fa fa-align-justify"></i> ADD NEW SALES
                </span>
            </div>
            <div class="card-body" style="padding: 0;">
                <div style="padding: 15px;">
                    <div class="row">
                        <div class="col-sm-6">
                            <label>CUSTOMER</label>
                            <select class="form-control form-control-sm">
                            </select>
                        </div>
                    </div><br/>
                    <div class="row">
                        <div class="col-sm-4">
                            <label>BILL TO</label>
                            <textarea class="form-control form-control-sm"></textarea>
                        </div>
                        <div class="col-sm-4">
                            <label>SHIP TO</label>
                            <textarea class="form-control form-control-sm"></textarea>
                        </div>
                        <div class="col-sm-4">
                            <table align="right">
                                <tbody>
                                    <tr>
                                        <td>លេខវក័យបត្រ</td>
                                        <td>:</td>
                                        <td>
                                            <input type="text" class="form-control form-control-sm"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Date</td>
                                        <td>:</td>
                                        <td>
                                            <input type="text" class="form-control form-control-sm"/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <table class="table no-bor">
                    <thead>
                        <tr>
                            <td>លរ</td>
                            <td>ទំនិញសេវាកម្ម</td>
                            <td>ខ្នាត</td>
                            <td>បរិមាណ</td>
                            <td>តំលៃ</td>
                            <td>សរុប</td>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
</style>